export const DPI_CHARGES = "DPI_CHARGES";
export const DPI_DETAILS = "DPI_DETAILS";
